namespace Matrix.Data {
    export interface InstanceForm {
        InstanceCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
    }

    export class InstanceForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Instance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!InstanceForm.init)  {
                InstanceForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(InstanceForm, [
                    'InstanceCode', w0,
                    'Name', w0
                ]);
            }
        }
    }
}
